import React, { useEffect, useState, useContext } from "react";
import axios from 'axios';
import DataSnapshots from "components/Private/BaolinEventsAnalytics/NewYear/DataSnapshots";
import ChartsContext from "../../contexts/ChartsContext";

// react-bootstrap components
import {
  Container,
} from "react-bootstrap";
import InsightCharts from "components/Private/BaolinEventsAnalytics/NewYear/InsightCharts";

function NewYearDashboard() {
  const { setChartsData, setUpdateTime, checkin3R5P } = useContext(ChartsContext);
  const fetchEventStatistics = () => {
    axios.get(`${process.env.REACT_APP_SERVER_URL}/newyear/geteventstatistics?event=newyear`)
      .then(response => {
        const currentTime = new Date().toLocaleString();
        setUpdateTime(currentTime);
        console.log("API Response Data:", response.data);
        console.log("New Year Event Data Mapping:", {
          totalEntriesEvent1: response.data?.totalEntriesEvent1 || "NOT IN API",
          totalEntriesEvent2: response.data?.totalEntriesEvent2 || "NOT IN API",
          totalTodayEvent1: response.data?.totalTodayEvent1 || "NOT IN API",
          totalTodayEvent2: response.data?.totalTodayEvent2 || "NOT IN API",
          headcountEvent1: response.data?.headcountEvent1,
          headcountEvent2: response.data?.headcountEvent2,
          checkInGroupSizeEvent1: response.data?.checkInGroupSizeEvent1,
          checkInGroupSizeEvent2: response.data?.checkInGroupSizeEvent2,
          totalEntries: response.data?.totalEntries,
          totalToday: response.data?.totalToday,
          registrationPerDay: response.data?.registrationPerDay,
          registrationPerDayEvent1: response.data?.registrationPerDayEvent1 || "NOT IN API",
          registrationPerDayEvent2: response.data?.registrationPerDayEvent2 || "NOT IN API"
        });
        setChartsData(response.data);
        // fetch3R5PStatistics()
      })
      .catch(error => {
        console.error("Error fetching event statistics:", error);
      });
  };

  useEffect(() => {
    fetchEventStatistics(); // Initial data fetch
  }, []);
  return (
    <>
      <Container fluid>
        <DataSnapshots onRefresh={fetchEventStatistics} />
        <InsightCharts onRefresh={fetchEventStatistics} />
      </Container>
    </>

  );
}

export default NewYearDashboard;
